export { default } from './GalleryBlockWithText';
